import { auth0UserAtom } from './auth0UserAtom'
import { createAtomWithLocalStorage } from './utils'

const atomWithLocalStorage = <Value>(key: string) =>
  createAtomWithLocalStorage<Value>((get) => {
    const user = get(auth0UserAtom)

    return ['app', user?.sub, key].join('::')
  })

/**
 * 最後に訪問したブランドアカウントIDを保持するatom。
 */
export const lastBrandAccountIdAtom =
  atomWithLocalStorage<string>('lastBrandAccountId')

/**
 * 最後に訪問したサーベイIDを保持するatom。
 */
export const lastSurveyIdAtom = atomWithLocalStorage<string>('lastSurveyId')

/**
 * ブランドアカウントIDと最後に訪問したサーベイIDのマップを保持するatom。
 */
export const brandAccountIdLastSurveyIdMapAtom = atomWithLocalStorage<
  Record<string, string>
>('brandAccountIdLastSurveyIdMap')

/**
 * ブランドアカウントIDと最後に訪問したサーベイグループIDのマップを保持するatom。
 */
export const brandAccountIdLastSurveyGroupIdMapAtom = atomWithLocalStorage<
  Record<string, string>
>('brandAccountIdLastSurveyGroupIdMap')
